import React, { useState } from "react";
import axios from "../../utils/axiosInstance";
import { useNavigate } from "react-router-dom";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [sending, setSending] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    const cleanEmail = String(email || "").trim().toLowerCase();
    if (!cleanEmail) {
      setError("Please enter your email.");
      return;
    }

    try {
      setSending(true);
      const res = await axios.post("/auth/forgotPassword", { email: cleanEmail });

      // backend returns generic msg always
      setMessage(res.data.message || "If an account exists, a reset link was sent.");
    } catch (err) {
      console.error("Forgot password error:", err);
      setError(err.response?.data?.message || "Error sending reset link. Try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded shadow w-full max-w-sm text-center"
      >
        <h2 className="text-xl font-bold mb-4">Forgot Password</h2>

        {error && <div className="text-red-500 mb-3">{error}</div>}
        {message && <div className="text-green-600 mb-3">{message}</div>}

        <input
          type="email"
          placeholder="Enter your registered email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full p-2 border mb-4 rounded"
          required
        />

        <button
          type="submit"
          disabled={sending}
          className="bg-blue-500 text-white px-4 py-2 rounded w-full hover:bg-blue-600 transition disabled:opacity-50"
        >
          {sending ? "Sending..." : "Send Reset Link"}
        </button>

        <div className="mt-4 text-sm text-gray-600">
          <button
            type="button"
            onClick={() => navigate("/login")}
            className="text-blue-600 hover:underline"
          >
            Back to Login
          </button>
        </div>
      </form>
    </div>
  );
}
